import React from "react";
import StoriesContainer from "./components/stories_container";
import Story_empty from "./components/story_empty";

export default function Stories({
  setAddStoryModal,
  setDeleteStoryModal,
  storiesList,
  isOwner,
  storiesPaginationStates,
  setDeletingStoryID,
  storyPrevPage,
  storyNextPage,
  storiesSortByOptions,
  storiesSortByActive,
  SetStoriesSortByActive,
  isLoading,
}) {
  return (
    <div className="stories-container">
      <h5>Stories</h5>
      {storiesList.length == 0 ? (
        <Story_empty setAddStoryModal={setAddStoryModal} isOwner={isOwner} />
      ) : (
        <StoriesContainer
          setAddStoryModal={setAddStoryModal}
          SetStoriesSortByActive={SetStoriesSortByActive}
          storiesList={storiesList}
          storiesSortByActive={storiesSortByActive}
          setDeletingStoryID={setDeletingStoryID}
          isLoading={isLoading}
          storiesSortByOptions={storiesSortByOptions}
          storyNextPage={storyNextPage}
          storyPrevPage={storyPrevPage}
          setDeleteStoryModal={setDeleteStoryModal}
          isOwner={isOwner}
          storiesPaginationStates={storiesPaginationStates}
        />
      )}
    </div>
  );
}
